import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class RoleHelperService {
  normalizeRole(role: unknown): "prestataire" | "client" {
    const value = String(role ?? "").trim().toLowerCase();
    if (value === "provider" || value === "prestataire") {
      return "prestataire";
    }
    return "client";
  }

  extractRoleFromUser(user: any): "prestataire" | "client" {
    const rawRole = Array.isArray(user?.roles)
      ? typeof user.roles[0] === "string"
        ? user.roles[0]
        : user.roles[0]?.name
      : user?.role;
    return this.normalizeRole(rawRole);
  }

  isPrestataireUser(user: any): boolean {
    return this.extractRoleFromUser(user) === "prestataire";
  }
}
